var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"0vxR7EH13tmKVpcjnVCfI"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/undefined/cms/master";

import { type SamplingContext } from '@sentry/types'
import { browserTracingIntegration } from '@sentry/nextjs'

import getConfig from 'next/config'
import { Env, getSampleRatesByEnv, sentryInit } from './sentry.config'

const { publicRuntimeConfig } = getConfig()

// We collect transaction (WebVitals and other metrics) only for certain pages
const allowedPageSlugs = new Set(['/a', '/desktop', '/grammar-checker'])
const env = publicRuntimeConfig.GR_ENV as Env
const sampleRates = getSampleRatesByEnv(env)

sentryInit(env, {
  tracesSampler: (samplingContext: SamplingContext) => {
    return allowedPageSlugs.has(samplingContext.location?.pathname ?? '') ? sampleRates.tracesSampleRate : 0
  },
  integrations: [browserTracingIntegration()],
  ...sampleRates,
})
